module.exports = __webpack_public_path__ + "static/88a8cbb0.Tracking.png";